import { createFileRoute } from "@tanstack/react-router";
import { SiteShell } from "@/components/site/SiteShell";
import { OutcomeCaseStudyArticle } from "@/components/resources/OutcomeCaseStudyArticle";
import { buildHead, breadcrumbJsonLd } from "@/lib/seo";
import { articleJsonLdForPillar } from "@/components/site/PillarArticle";
import { setEdgeHtmlCache } from "@/lib/cache-headers";
import body from "../../content/resources/self-care-is-for-everyone-shopify-growth-case-study.es.md?raw";

const PATH = "/es/recursos/caso-self-care-is-for-everyone-crecimiento";
const ALT = "/resources/self-care-is-for-everyone-growth-case-study";
const TITLE = "Self-Care Is For Everyone: una tienda Shopify custom construida para crecer";
const META_TITLE = "Caso Self-Care Is For Everyone en Shopify · Shugert";
const DESCRIPTION = "Cómo Self-Care Is For Everyone reconstruyó Shopify para lanzamientos de marca, registrando +42% de CVR y -46% de LCP móvil.";
const PUBLISHED = "2026-08-20T14:30:00.000Z";
const MODIFIED = "2026-08-20T14:30:00.000Z";

const SOURCES = [
  { label: "Perfil de Shugert Marketing", publisher: "Shopify", href: "https://www.shopify.com/partners/directory/partner/shugert-marketing" },
  { label: "Self-Care Is For Everyone", publisher: "Self-Care Is For Everyone", href: "https://selfcareisforeveryone.com/" },
  { label: "Resultados publicados del proyecto", publisher: "Shugert", href: "https://shugert.com.mx/work" },
  { label: "Largest Contentful Paint", publisher: "web.dev", href: "https://web.dev/articles/lcp" },
];

const RELATED = [
  { label: "Rendimiento Shopify", href: "/es/rendimiento" },
  { label: "CRO Shopify", href: "/es/cro-shopify" },
  { label: "Desarrollo Shopify", href: "/es/desarrollo-shopify" },
  { label: "Todos los casos Shopify", href: "/es/proyectos" },
];

export const Route = createFileRoute("/es/recursos/caso-self-care-is-for-everyone-crecimiento")({
  loader: async () => { await setEdgeHtmlCache(); },
  head: () => buildHead({
    locale: "es", title: META_TITLE, description: DESCRIPTION, path: PATH, altPath: ALT, type: "article",
    author: "Samuel Noriega", articleAuthor: "Samuel Noriega", articleSection: "Caso de crecimiento Shopify", publishedTime: PUBLISHED, modifiedTime: MODIFIED,
    jsonLd: [
      articleJsonLdForPillar({ title: TITLE, description: DESCRIPTION, path: PATH, publishedTime: PUBLISHED, modifiedTime: MODIFIED, section: "Caso de crecimiento Shopify" }),
      breadcrumbJsonLd([{ name: "Inicio", path: "/es" }, { name: "Proyectos", path: "/es/proyectos" }, { name: "Caso Self-Care Is For Everyone", path: PATH }]),
    ],
  }),
  component: () => (
    <SiteShell>
      <OutcomeCaseStudyArticle
        locale="es" path={PATH} title={TITLE}
        excerpt="Cómo una marca con misión pasó de un theme legacy a una plataforma Shopify custom preparada para colaboraciones visibles, mejor performance móvil y lanzamientos repetibles."
        body={body} updated="Agosto de 2026" publishedAt={PUBLISHED} modifiedAt={MODIFIED} readingMinutes={10}
        focus="Cómo arquitectura custom, UX de campañas, performance móvil, componentes reutilizables y SEO continuo apoyaron el crecimiento de una marca Shopify."
        audience="Marcas Shopify cuyos drops, colaboraciones o campañas ya superaron las limitaciones de un theme legacy y necesitan resultados medibles de rendimiento y conversión."
        sources={SOURCES} related={RELATED}
        category="Caso de crecimiento y theme custom Shopify" backLabel="← Proyectos" backHref="/es/proyectos"
        cta={{ eyebrow: "Shopify preparado para lanzamientos", title: "Construye para la siguiente campaña, no solo para la actual.", body: "Definimos builds Shopify custom alrededor del customer journey, performance, workflows reutilizables y resultados comerciales medibles.", label: "Solicitar alcance de build", href: "/es/cotizacion?intent=rebuild&source=self-care-case-study" }}
      />
    </SiteShell>
  ),
});
